import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AttachmentIcon from '@material-ui/icons/Attachment';
import Associations from '../Associations';
import { ProjectConsumer } from '../providers/ProjectProvider';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import IRIgeneration from '../../core/IRIgeneration';
import SlashHash from '../../core/SlashHash';
import GS from '../../grafsync/grafsync';
import ImportStepper from '../ImportStepper';
import { globalStyles } from '../style/gstheme';
import { getGraphFromProject, makeCancelable } from '../utils/utils';
import Warning from '../Warning';
import SelectFile from './SelectFile';
import SheetPreview from '../spreadsheet/SheetPreview';
import Upload from './Upload';
import MinorIssues from '../MinorIssues';

const styles = theme => {
    return Object.assign({
        importOuter: {
            backgroundColor: theme.palette.grey[100],
            marginBottom: '10px',
            borderRadius: '4px',
            textAlign: 'center',
            padding: '18px',
            minHeight: '250px',
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        showFile: {
            backgroundColor: theme.palette.grey[200],
            fontWeight: 500,
            borderRadius: '6px',
            color: theme.palette.primary.main,
            padding: '10px'
        },
        importInner: {
            border: 'solid 1px ' + theme.palette.grey[500],
            backgroundColor: theme.palette.grey[100],
            borderRadius: '4px',
            textAlign: 'center',
            paddingTop: 30,
            minHeight: '200px',
            paddingBottom: 20
        }
    }, globalStyles);
};

const steps = ['Select File', 'Options', 'Upload'];

class SelectOptions extends React.Component {

    toggleMinorIssues = (event) => {
        const t = event.target;
        this.props.onToggleMinorIssues(t.value === "true");
    };

    handleSlashHashChange = event => {
        const t = event.target;
        this.props.onSlashHashSelect(t.value);
    };

    handleFormatChange = event => {
        const t = event.target;
        this.props.onIRIformatSelect(t.value);
    };

    updateMapping = (updatedMapping, updatedSpreadsheetOptions, validSpreadsheet) => {
        this.props.onUpdateMapping(updatedMapping, updatedSpreadsheetOptions, validSpreadsheet);
    };

    render() {

        const { iriType, iriFormat, isSpreadsheet, file, project, optionForXL, spreadsheetOptions, filename,
            includeOptions, limits, ontologyProjectAssociation, taxonomies, collections, allowMinorIssues, issueManagement } = this.props;

        return (
            <ProjectConsumer>
                {({ defaultLang }) => (
                    <div style={{ marginBottom: 70 }}>
                        <div className={this.props.classes.importOuter}>
                            <div className={this.props.classes.importInner}
                                style={{
                                    paddingTop: 0,
                                    textAlign: 'left',
                                    paddingLeft: 20,
                                    paddingRight: 20,
                                    paddingBottom: issueManagement ? 20 : 30
                                }}>
                                {!isSpreadsheet ?
                                    <React.Fragment>
                                        {issueManagement ?
                                            <Grid container spacing={1}>
                                                <Grid item xs={6}>
                                                    <SlashHash onChange={this.handleSlashHashChange} iriType={iriType} />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <IRIgeneration onChange={this.handleFormatChange} iriFormat={iriFormat} />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <MinorIssues
                                                        onChange={this.toggleMinorIssues}
                                                        margin={true}
                                                        allowMinorIssues={allowMinorIssues} />
                                                </Grid>
                                            </Grid>
                                            :
                                            <React.Fragment>
                                                <SlashHash onChange={this.handleSlashHashChange} iriType={iriType} />
                                                <IRIgeneration onChange={this.handleFormatChange} iriFormat={iriFormat} />
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                    :
                                    ontologyProjectAssociation ?
                                        <Associations
                                            graph={getGraphFromProject(project)}
                                            onLoad={this.onLoadAssociations}
                                            ontologyProjectAssociation={ontologyProjectAssociation}
                                            component={SheetPreview}
                                            id={project}
                                            file={file}
                                            project={project}
                                            collections={collections}
                                            taxonomies={taxonomies}
                                            initialSettings={{
                                                ignoreHeaderRow: spreadsheetOptions.ignoreHeaderRow,
                                                ignoreInvalidValues: spreadsheetOptions.ignoreInvalidValues,
                                                useXL: spreadsheetOptions.useXL,
                                                title: spreadsheetOptions.title,
                                                baseIRI: spreadsheetOptions.baseIRI,
                                                defaultLang: spreadsheetOptions.lang,
                                                mapping: this.props.mapping !== undefined && this.props.mapping.length > 0 ? this.props.mapping : null
                                            }}
                                            iriType={iriType}
                                            limits={limits}
                                            includeOptions={includeOptions}
                                            iriFormat={iriFormat}
                                            optionForXL={optionForXL}
                                            onSlashHashChange={this.handleSlashHashChange}
                                            onFormatChange={this.handleFormatChange}
                                            defaultLang={defaultLang}
                                            onUpdateMapping={this.updateMapping}
                                        />
                                        :
                                        <SheetPreview
                                            file={file}
                                            project={project}
                                            iriType={iriType}
                                            limits={limits}
                                            collections={collections}
                                            taxonomies={taxonomies}
                                            initialSettings={{
                                                ignoreHeaderRow: spreadsheetOptions.ignoreHeaderRow,
                                                ignoreInvalidValues: spreadsheetOptions.ignoreInvalidValues,
                                                useXL: spreadsheetOptions.useXL,
                                                title: spreadsheetOptions.title,
                                                baseIRI: spreadsheetOptions.baseIRI,
                                                defaultLang: spreadsheetOptions.lang,
                                                mapping: this.props.mapping !== undefined && this.props.mapping.length > 0 ? this.props.mapping : null
                                            }}
                                            includeOptions={includeOptions}
                                            iriFormat={iriFormat}
                                            optionForXL={optionForXL}
                                            onSlashHashChange={this.handleSlashHashChange}
                                            onFormatChange={this.handleFormatChange}
                                            defaultLang={defaultLang}
                                            onUpdateMapping={this.updateMapping} />
                                }
                            </div>
                        </div>
                        {!isSpreadsheet && filename &&
                            <Typography data-test="attached-file" className={this.props.classes.showFile} paragraph>
                                <AttachmentIcon style={{ verticalAlign: 'bottom', marginRight: '10px' }} />
                                {filename}
                            </Typography>
                        }

                    </div>
                )}
            </ProjectConsumer>
        );
    }
}

const stateReset = {
    filename: null,
    started: false,
    file: null,
    normalisation: null,
    message: null,
    uuid: null,
    uploaded: false,
    isErrored: false,
    isSpreadsheet: false,
    completionMessage: false,
    baseIRI: "",
    sheetData: null,
    mapping: [],
    transfer: null,
    status: null,
    allowMinorIssues: true,
    slashHash: "Slash",
    iriFormat: "UUID",
    validSpreadsheet: false,
    spreadsheetOptions: {},
    errorMessage: null
};

class ProjectImport extends React.Component {

    constructor(props) {
        super(props);
        this.state = Object.assign(stateReset, {});
        this.cancellable = null;
        this.clickRef = React.createRef();
    }

    componentWillUnmount() {
        if (this.hcTimeout) clearTimeout(this.hcTimeout);
        if (this.cancellable) this.cancellable.cancel();
    }

    onToggleMinorIssues = (allowMinorIssues) => this.setState({ allowMinorIssues });

    onSlashHashSelect = (slashHash) => this.setState({ slashHash });

    onIRIformatSelect = (iriFormat) => this.setState({ iriFormat });

    onUpdateMapping = (updatedMapping, updatedSpreadsheetOptions, validSpreadsheet) => {
        const mapping = [...updatedMapping];
        const spreadsheetOptions = this.props.includeOptions ?
            Object.assign({}, updatedSpreadsheetOptions)
            :
            Object.assign(this.props.useOptions, {
                useXL: updatedSpreadsheetOptions.useXL,
                ignoreInvalidValues: updatedSpreadsheetOptions.ignoreInvalidValues,
                ignoreHeaderRow: updatedSpreadsheetOptions.ignoreHeaderRow,
            });
        this.setState({ mapping, spreadsheetOptions, validSpreadsheet });
    };

    onSelectFile = (data) => {
        // The next line shouldn't be necessary
        if (data.length === 0 || data.length > 1) return;
        let isSpreadsheet = false;
        const name = data[0].name;
        if (name.includes('.csv') || name.includes('.tsv') || name.includes('.xlsx') || name.includes('.csv') || name.includes('.txt')) {
            isSpreadsheet = true;
        }
        this.setState({ filename: data[0].path, file: data[0], isSpreadsheet });
    };

    waitForCompletion = (msg) => {
        if (this.cancellable && this.cancellable.isCancelled()) return;
        const graph = getGraphFromProject(this.props.project);
        if (msg.graphIRI === graph) {
            this.setState({ completionMessage: true });
        }
    };

    uploadFile = async () => {
        const { file, mapping, spreadsheetOptions } = this.state;
        try {
            await file.slice(0, 1).arrayBuffer();
        }
        catch (e) {
            this.setState({
                isErrored: true,
                errorMessage: "Cannot access file. It may have changed. Please start again."
            });
            return;
        }
        const importContext = this.props.importContext;
        let uploadMapping = {};
        if (spreadsheetOptions && Object.keys(spreadsheetOptions).length > 0) uploadMapping.spreadsheetOptions = spreadsheetOptions;
        if (mapping && mapping.length > 0) uploadMapping.mapping = mapping;
        this.cancellable = makeCancelable(
            GS.upload(file, this.props.project, getGraphFromProject(this.props.project), [
                {
                    property: "https://grafsync.graphifi.com/schema/gs/useSlashIRI",
                    value: this.props.useSlashIRI !== null && this.props.useSlashIRI !== undefined ?
                        this.props.useSlashIRI
                        :
                        this.state.slashHash === "Slash"
                },
                {
                    property: "https://grafsync.graphifi.com/schema/gs/useUuidIRI",
                    value: this.props.useUuidIRI !== null && this.props.useUuidIRI !== undefined ?
                        this.props.useUuidIRI
                        :
                        this.state.iriFormat === "UUID"
                },
                {
                    property: "https://grafsync.graphifi.com/schema/gs/allowMinorIssues",
                    value: this.props.issueManagement !== null && this.props.issueManagement !== undefined ?
                        this.state.allowMinorIssues
                        :
                        false
                }
            ],
                uploadMapping,
                importContext,
                this.waitForCompletion)
                .then(resp => {
                    if (this.cancellable && !this.cancellable.isCancelled()) {
                        this.setState({ uuid: resp.filename, uploaded: true });
                        this.watchUpload();
                    }
                })
                .catch((e) => {
                    if (this.cancellable && !this.cancellable.isCancelled()) this.setState({
                        isErrored: true,
                        errorMessage: e.message
                    });
                })
        );
        return this.cancellable;
    };

    watchUpload = () => {
        if (this.hcTimeout) clearTimeout(this.hcTimeout);
        this.hcTimeout = setTimeout(async () => {
            try {
                let status = await GS.uploadStatus(this.state.uuid);
                if (this.cancellable && !this.cancellable.isCancelled()) {
                    this.setState({
                        ...(status.transfer !== undefined) && { transfer: status.transfer },
                        ...(status.normalisation) && { normalisation: status.normalisation },
                        ...(status.message) && { message: status.message },
                        ...(status.status) && { status: status.status },
                        ...(status.stepCount) && { stepCount: status.stepCount }
                    });
                    // Keep looping until ready
                    if (this.clickRef && this.clickRef.current) {
                        this.clickRef.current.click();
                    }
                    if (status.transfer === undefined) this.watchUpload();
                }
            }
            catch (e) {
                if (this.cancellable && this.cancellable.isCancelled()) return;
                this.setState({
                    transfer: false,
                    isErrored: true,
                    errorMessage: e.message
                });
            }
        }, 2000);
    };

    getStepContent = (step) => {
        if (step === 2 && !this.state.uploaded) this.uploadFile();

        switch (step) {
            case 0:
                return <SelectFile
                    classes={this.props.classes}
                    additionalExtensions={this.props.additionalExtensions}
                    spreadsheetOnly={this.props.spreadsheetOnly}
                    filename={this.state.filename}
                    enableSpreadsheet={this.props.enableSpreadsheet}
                    onSelectFile={this.onSelectFile} />;
            case 1:
                return <SelectOptions
                    onBaseIRIChange={this.onBaseIRIChange}
                    classes={this.props.classes}
                    file={this.state.file}
                    issueManagement={this.props.issueManagement}
                    allowMinorIssues={this.state.allowMinorIssues}
                    collections={this.props.collections}
                    taxonomies={this.props.taxonomies}
                    limits={this.props.spreadsheetOnly ? "partial" : null}
                    isSpreadsheet={this.state.isSpreadsheet}
                    project={this.props.project}
                    includeOptions={this.props.includeOptions}
                    ontologyProjectAssociation={this.props.data ? this.props.data.ontologyProjectAssociation : null}
                    optionForXL={this.props.data ? this.props.data.skosXL : null}
                    iriType={this.state.slashHash}
                    iriFormat={this.state.iriFormat}
                    filename={this.state.filename}
                    mapping={this.state.mapping}
                    spreadsheetOptions={this.state.spreadsheetOptions}
                    onUpdateMapping={this.onUpdateMapping}
                    onToggleMinorIssues={this.onToggleMinorIssues}
                    onSlashHashSelect={this.onSlashHashSelect}
                    onIRIformatSelect={this.onIRIformatSelect} />;
            case 2:
                return <Upload
                    message={this.state.message}
                    disableScreen={this.props.disableScreen}
                    transfer={this.state.transfer}
                    status={this.state.status}
                    issueManagement={this.props.issueManagement}
                    allowMinorIssues={this.state.allowMinorIssues}
                    filename={this.state.filename}
                    stepCount={this.state.stepCount}
                    normalisation={this.state.normalisation} />;
            default:
                return 'Unknown step';
        }
    };

    canContinue = (step) => {
        if (step === 0 && this.state.filename === null) return false;
        if (step === 1 && this.state.isSpreadsheet && !this.state.validSpreadsheet) return false;
        if (step === 2 && this.state.transfer !== false && this.state.completionMessage === false) return false;
        if (step === 2 && this.state.transfer === null) return false;
        return true;
    };

    canGoBack = (step) => {
        if (step === 2 && this.state.transfer !== false) return false;
        return true;
    };

    handleReset = () => this.setState(Object.assign(stateReset));

    handleBack = () => this.setState({
        transfer: null,
        uploaded: false
    });

    onComplete = async () => {
        this.setState(Object.assign(stateReset));
        // We need to force a reload because loaded resources may have been impacted
        await GS.unload();
        // We reload the project to make sure it is loaded
        const project = this.props.project;
        await GS.loadData([project], {}, getGraphFromProject(project));
        let link = this.props.baseLink + '#project=' + project;
        if (this.props.subLink) {
            link += "&" + this.props.subLink;
        }
        this.props.history.push(link);
    };

    onExitWarning = () => this.setState(Object.assign(stateReset));

    render() {

        const { isErrored, errorMessage, transfer, isSpreadsheet } = this.state;
        const { classes, importUnavailable, center } = this.props;

        if (isErrored) return <Warning message={errorMessage} onExitWarning={this.onExitWarning} />;

        return (
            <div className={classes.import} ref={this.clickRef} style={{
                ...(!isSpreadsheet) && { maxWidth: '743px' },
                ...(center) && {
                    marginLeft: 'auto',
                    marginRight: 'auto'
                },
                ...(!center) && {
                    marginRight: 30
                }
            }}>
                <ImportStepper
                    importUnavailable={importUnavailable}
                    steps={steps}
                    getStepContent={this.getStepContent}
                    title="Import data"
                    errored={transfer === false}
                    canGoBack={this.canGoBack}
                    canContinue={this.canContinue}
                    handleReset={this.handleReset}
                    handleBack={this.handleBack}
                    onError={this.onExitWarning}
                    onComplete={this.onComplete} />
            </div>
        );
    }
}

ProjectImport.defaultProps = {
    importUnavailable: null,
    disableScreen: false,
    includeOptions: true,
    enableSpreadsheet: false,
    issueManagement: false
};

ProjectImport.propTypes = {
    importContext: PropTypes.object,
    additionalExtensions: PropTypes.array,
    classes: PropTypes.object,
    data: PropTypes.object,
    subLink: PropTypes.string,
    center: PropTypes.bool,
    spreadsheetOnly: PropTypes.bool,
    includeOptions: PropTypes.bool,
    useSlashIRI: PropTypes.bool,
    useUuidIRI: PropTypes.bool,
    disableScreen: PropTypes.bool,
    history: PropTypes.object,
    useOptions: PropTypes.object,
    project: PropTypes.string.isRequired,
    importUnavailable: PropTypes.string,
    enableSpreadsheet: PropTypes.bool,
    issueManagement: PropTypes.bool,
    baseLink: PropTypes.string.isRequired
};

SelectOptions.propTypes = {
    classes: PropTypes.object,
    issueManagement: PropTypes.bool,
    onToggleMinorIssues: PropTypes.func,
    onSlashHashSelect: PropTypes.func,
    onIRIformatSelect: PropTypes.func,
    onUpdateMapping: PropTypes.func,
    mapping: PropTypes.array,
    allowMinorIssues: PropTypes.bool,
    onBaseIRIChange: PropTypes.func,
    spreadsheetOptions: PropTypes.object,
    iriFormat: PropTypes.string,
    isSpreadsheet: PropTypes.bool,
    includeOptions: PropTypes.bool,
    ontologyProjectAssociation: PropTypes.array,
    useOptions: PropTypes.object,
    filename: PropTypes.string,
    file: PropTypes.object,
    lang: PropTypes.string,
    collections: PropTypes.array,
    taxonomies: PropTypes.array,
    project: PropTypes.string,
    limits: PropTypes.string,
    onSpreadsheetLangSelect: PropTypes.func,
    optionForXL: PropTypes.bool,
    isValidIRI: PropTypes.bool,
    sheetData: PropTypes.object,
    iriType: PropTypes.string,
    baseIRI: PropTypes.string
};

export default withRouter(withStyles(styles)(ProjectImport));